import {useNavigate} from 'react-router-dom';
import MedicalHistoryComponent from './component';
import {getRoute, RouteSection} from '$utils/route';
import {RoutePath} from '$constants/routes';
import {useMedicalHistory} from '~/services/api/MedicalHistory/hooks';
import {QuestionnaireType} from '~/services/api/MedicalHistory/Questionnaire/types';

interface MedicalHistoryProps {
  patientId: number;
}

function MedicalHistory(props: MedicalHistoryProps) {
  const {patientId} = props;

  const {
    medicalHistory,
    isMedicalHistoryLoading,
    isMedicalHistoryFetchError,
    downloadMedicalHistoryPDF,
  } = useMedicalHistory(patientId);

  const navigate = useNavigate();

  const handleOpenQuestionnaire = (questionnaireType: QuestionnaireType) => {
    navigate(
      getRoute(
        RouteSection.PatientList,
        patientId.toString(),
        RoutePath.staff.patientList.questionnaire
      ),
      {
        state: {
          type: questionnaireType,
        },
      }
    );
  };

  return (
    <MedicalHistoryComponent
      isMedicalHistoryLoading={isMedicalHistoryLoading}
      isMedicalHistoryFetchError={isMedicalHistoryFetchError}
      medicalHistory={medicalHistory}
      onEditIconClick={handleOpenQuestionnaire}
      onDownloadClick={downloadMedicalHistoryPDF}
    />
  );
}

export default MedicalHistory;
